var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconProtectionGdy5X3Bch7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Captions"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3CC8B4",
    d: "M37.042,6.522L31.998,4l-5.044,2.522C25.009,7.494,22.866,8,20.693,8h-4.695v20.111 c0,6.06,3.424,11.601,8.845,14.311L31.998,46l7.155-3.578c5.421-2.71,8.845-8.25,8.845-14.311V8h-4.695 C41.129,8,38.986,7.494,37.042,6.522z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1EAA96",
    d: "M28.842,42.422c-5.421-2.71-8.845-8.25-8.845-14.311V8h-4v20.111c0,6.06,3.424,11.601,8.845,14.311 L31.998,46l2-1L28.842,42.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FAB400",
    d: "M37.998,34h-12c-1.105,0-2-0.895-2-2V22c0-1.105,0.895-2,2-2h12c1.105,0,2,0.895,2,2v10 C39.998,33.105,39.102,34,37.998,34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DC9600",
    d: "M25.998,32V22c0-1.105,0.895-2,2-2h-2c-1.105,0-2,0.895-2,2v10c0,1.105,0.895,2,2,2h2 C26.893,34,25.998,33.105,25.998,32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M27.998,20v-5c0-0.552,0.448-1,1-1h6c0.552,0,1,0.448,1,1v5h2v-5c0-1.657-1.343-3-3-3h-6 c-1.657,0-3,1.343-3,3v5H27.998z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BE7800",
    d: "M33.998,26c0-1.105-0.895-2-2-2s-2,0.895-2,2c0,0.738,0.405,1.376,1,1.723V29c0,0.552,0.448,1,1,1 s1-0.448,1-1v-1.277C33.593,27.376,33.998,26.738,33.998,26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.999,
    y: 54,
    fill: "#505050",
    width: 12,
    height: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.999,
    y: 54,
    fill: "#3C3C3C",
    width: 4,
    height: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.999,
    y: 54,
    fill: "#505050",
    width: 12,
    height: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 41.999,
    y: 54,
    fill: "#3C3C3C",
    width: 4,
    height: 6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0C8A0",
    d: "M59.992,28h-0.299c-0.978,0-1.812,0.707-1.973,1.671l-1.3,7.8c-0.274,1.645-1.055,3.163-2.234,4.341 L51.999,44l1.578-3.156c0.278-0.555,0.422-1.168,0.422-1.789v-0.642c0-0.891-1.077-1.337-1.707-0.707l-5.95,5.95 c-1.5,1.5-2.343,3.535-2.343,5.657V54h8v-1.929c0-1.326,0.527-2.598,1.464-3.535l4.191-4.191 c1.501-1.501,2.344-3.531,2.343-5.653C59.996,34.552,59.993,28.001,59.992,28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F0C8A0",
    d: "M4.005,28h0.299c0.978,0,1.812,0.707,1.973,1.671l1.3,7.8c0.274,1.645,1.055,3.163,2.234,4.341L11.999,44 l-1.578-3.156c-0.278-0.555-0.422-1.168-0.422-1.789v-0.642c0-0.891,1.077-1.337,1.707-0.707l5.95,5.95 c1.5,1.5,2.343,3.535,2.343,5.657V54h-8v-1.929c0-1.326-0.527-2.598-1.464-3.535l-4.191-4.191 C4.842,42.843,3.999,40.814,4,38.691C4.002,34.552,4.004,28.001,4.005,28z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconProtectionGdy5X3Bch7);
export default __webpack_public_path__ + "static/media/reshot-icon-protection-GDY5X3BCH7.73f7eb699a20209835b37b590ff9a691.svg";
export { ForwardRef as ReactComponent };